class BannerAd{

	constructor(){

		this.pinningStartedOnce = false;

	}

	enableBannerPinning(){

		console.log("ad size banner pin - start pinning");

		/*
		 'dfp.beforeInit',
		 'dfp.afterInit',
		 'dfp.updateCorrelator',
		 'dfp.defineSlot',
		 'dfp.slotBeforeDefine',
		 'dfp.slotAfterDefine',
		 'dfp.refresh',
		 'dfp.slotRefresh',
		 'dfp.slotRenderEnded'
		 */

		window.addEventListener('dfp.slotBeforeDefine', (e) => {
			if(!this.pinningStartedOnce){
			this.registerSlotRendered();
			this.pinningStartedOnce = true;
		}

	});
	}

	registerSlotRendered(){

		console.log("ad size banner pin - register slot rendered ");

		//we need to check googletag.pubads. When the googltag is not on the page, it causes js error on console
		if (typeof googletag.pubads === "function") {

			googletag.pubads().addEventListener('slotRenderEnded', this.onSlotRenderEnded.bind(this));
			googletag.pubads().addEventListener('impressionViewable', this.onImpressionViewable.bind(this));
		
		}else{

			console.error("Ads - googletag.pubads is not a function");

		}

	}

	onSlotRenderEnded(ev){

		var slotId = ev.slot.getSlotElementId();
		var slotSize = ev.size.toString();

		//remove from refresh queue
		var queueIndex = this.refreshQueue.indexOf(slotId);
		(queueIndex > -1) && this.refreshQueue.splice(queueIndex, 1);

		//conditional logging
		this.log("Ads - slot Rendered for: " + slotId + " size: " + slotSize);
		this.logPerformanceMark("ADS_RENDER: " + slotSize);

		this.setPinning(slotSize);

	}

	onImpressionViewable(ev){

		window.lastiv = ev;

		var slotId = ev.slot.getSlotElementId();
		var size = ev.slot.getSizes()[0] || "dfp - no size";
		//size = size.getWidth() + "," + size.getHeight();

		//conditional logging
		this.log("Ads - slot ImpressionViewable for: " + slotId + " size: " + size);
		this.logPerformanceMark("ADS_VIEW: " + size);

	}

	//banner pinning logic
	setPinning(adSize){

		var isPinnableBanner = (adSize == '728,90' || adSize == '980,50' || adSize == '320,50' || adSize == '970,250') ? true : false;

		this.log("ad size banner pin " + adSize);

		if(isPinnableBanner){
			this.setBodyBannerAdSize(adSize);
		}

	}

	setBodyBannerAdSize(adSize){

		document.body.setAttribute("data-banner-ad-size", adSize);

	}


}

export default BannerAd;


// WEBPACK FOOTER //
// ./assets/components/ads/BannerAd.js